export const APP_VERSION = window._env_?.APP_VERSION;
